import React from 'react';
import { Skeleton } from 'primereact/skeleton';

const NoticeboardSkeletonLoader: React.FC = () => {
  return (
    <>
      {/* Loading Skeleton Header */}
      <div style={{
        padding: '16px 20px',
        borderBottom: '1px solid #f3f4f6',
        background: '#fafbfc',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 2s infinite'
          }}></div>
          <div style={{
            width: '200px',
            height: '16px',
            borderRadius: '8px',
            background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 2s infinite'
          }}></div>
        </div>
        <div style={{
          width: '100px',
          height: '32px',
          borderRadius: '8px',
          background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
          backgroundSize: '200% 100%',
          animation: 'shimmer 2s infinite'
        }}></div>
      </div>

      {/* Loading Skeleton Rows */}
      <div style={{ padding: '20px' }}>
        {[...Array(10)].map((_, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              padding: '16px',
              borderBottom: index < 9 ? '1px solid #f3f4f6' : 'none',
              animation: 'pulse 1.5s ease-in-out infinite',
              animationDelay: `${index * 0.1}s`
            }}
          >
            <div style={{
              width: '28px',
              height: '28px',
              borderRadius: '6px',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite',
              flexShrink: 0
            }}></div>

            <div style={{ flex: '1', minWidth: 0 }}>
              <div style={{
                width: '80%',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                marginBottom: '8px'
              }}></div>
              <div style={{
                width: '60%',
                height: '14px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>
            </div>

            <div style={{
              width: '80px',
              height: '28px',
              borderRadius: '20px',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite',
              flexShrink: 0
            }}></div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
              <div style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>
              <div style={{
                width: '90px',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>
            </div>

            <div style={{ flexShrink: 0 }}>
              <div style={{
                width: '100px',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                marginBottom: '6px'
              }}></div>
              <div style={{
                width: '80px',
                height: '14px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>
            </div>

            <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
              {[...Array(3)].map((_, i) => (
                <div
                  key={i}
                  style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                    backgroundSize: '200% 100%',
                    animation: 'shimmer 2s infinite'
                  }}
                ></div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Loading Skeleton Pagination */}
      <div style={{
        background: '#fafbfc',
        borderTop: '1px solid #e5e7eb',
        padding: '20px 16px',
        display: 'flex',
        justifyContent: 'center',
        gap: '8px'
      }}>
        {[...Array(7)].map((_, i) => (
          <div
            key={i}
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '8px',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite'
            }}
          ></div>
        ))}
      </div>
    </>
  );
};

export default NoticeboardSkeletonLoader;
